module.exports = __webpack_public_path__ + "img/how_it_work.1a578f13.png";